import { render } from "./CLoading.vue?vue&type=template&id=2c665f10&scoped=true"
const script = {}

import "./CLoading.vue?vue&type=style&index=0&id=2c665f10&lang=less&scoped=true"

import exportComponent from "/Users/ivan/Codes/ripple/wfj-vto-hub/node_modules/.pnpm/vue-loader@16.8.3_@vue+compiler-sfc@3.5.13_vue@3.5.13_webpack@4.47.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c665f10"]])

export default __exports__